import {Injectable} from "@angular/core";
import {ApiClient} from "../../../tools/api-client";
import {Observable} from "rxjs";
import {EditedHospital, HospitalDetails} from "./hospital.details";
import {MeasurementType} from "../../measurement-models";
import {map} from "rxjs/operators";
import {recursiveNullToUndefined} from "../../../tools/recursive-null-to-undefined";
import {ReportDeliveryNotification} from "./nurse-settings-section/nurse-settings-section.component";

export interface NurseSettings {
  hospitalId: number;
  nurse2Fa: boolean;
  reportDeliveryNotification: ReportDeliveryNotification;
  initiateWithDeviceSerial: boolean;
}

export interface PutHospitalInChainRequest {
  hospitalId: number;
  chainId: number;
}

const baseUrl = "/api/hospitals";

@Injectable()
export class EditHospitalService {
  constructor(private readonly apiClient: ApiClient) {
  }

  getHospital(id: number): Observable<EditedHospital> {
    return this.apiClient.get<EditedHospital>(`${baseUrl}/${id}`)
      .pipe(map((hospitalContext) =>
        ({
          ...hospitalContext,
          patientFormTemplateOptionsByMeasurementType: this.toMeasurementTypeMap(hospitalContext.patientFormTemplateOptionsByMeasurementType),
          hospitalDetails: {
            ...hospitalContext.hospitalDetails,
            selectedPatientFormTemplates: this.toMeasurementTypeMap(hospitalContext.hospitalDetails.selectedPatientFormTemplates),
          }
        })))
      .pipe(map((hospitalContext) => recursiveNullToUndefined(hospitalContext)));
  }

  private toMeasurementTypeMap(selectedPatientFormTemplates: any) {
    return new Map(Object.keys(selectedPatientFormTemplates)
      .map(key => [key as MeasurementType, selectedPatientFormTemplates[key]]));
  }

  addOperator(hospitalId: number, operatorId: number): Observable<any> {
    return this.apiClient.patch<any>(`${baseUrl}/add-operator`, {
      hospitalId: hospitalId,
      operatorId: operatorId
    });
  }

  removeOperator(hospitalId: number, operatorId: number) {
    return this.apiClient.patch<any>(`${baseUrl}/remove-operator`, {
      hospitalId: hospitalId,
      operatorId: operatorId
    });
  }

  saveDetails(hospitalId: number, hospitalDetails: HospitalDetails): Observable<void> {
    return this.apiClient.patch<void>(`${baseUrl}/${hospitalId}/details`, {
      ...hospitalDetails,
      selectedPatientFormTemplates: Object.fromEntries(hospitalDetails.selectedPatientFormTemplates.entries())
    });
  }
}
